export default __webpack_public_path__ + "static/media/axxes_black.4b34d3f0.svg";